import type { OfferingVorlage } from '../types';

export async function loadOfferingVorlagen(): Promise<OfferingVorlage[]> {
  const res = await fetch('/api/offering-vorlagen');
  if (!res.ok) throw new Error('Vorlagen konnten nicht geladen werden.');
  const data = (await res.json()) as unknown;
  return Array.isArray(data) ? (data as OfferingVorlage[]) : [];
}

export async function createOfferingVorlage(payload: {
  name: string;
  folder_id: string | null;
}): Promise<OfferingVorlage> {
  const res = await fetch('/api/offering-vorlagen', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? 'Anlegen fehlgeschlagen');
  return data as OfferingVorlage;
}

export async function renameOfferingVorlage(id: string, name: string): Promise<void> {
  const res = await fetch(`/api/offering-vorlagen/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? 'Speichern fehlgeschlagen');
}

export async function deleteOfferingVorlage(id: string): Promise<void> {
  const res = await fetch(`/api/offering-vorlagen/${encodeURIComponent(id)}`, { method: 'DELETE' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? 'Löschen fehlgeschlagen');
}
